Monitoring.Reports.Publications ||= {}

class Monitoring.Reports.Publications.AnalyticsView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publication_analytics/analytics']

  events:
    'click #facebook-social-network': 'onChangeToFacebookSocialNetwork'
    'click #twitter-social-network': 'onChangeToTwitterSocialNetwork'
    'click #instagram-social-network': 'onChangeToInstagramSocialNetwork'
    'click #own': 'filterOwnAccount'
    'click #competitors': 'filterThirdPartyAccount'
    'click #all': 'filterAllAccount'
    'click #export': 'download'
    'click #export-confirm': 'exportConfirm'

  initialize: (@options = {}) ->
    @facebookCompetitorsPages = @_createSortedListOfHashes(@options.facebookCompetitorsPages)
    @ownFacebookPages = @_createSortedListOfHashes(@options.ownFacebookPages)
    @instagramCompetitorsPages = @_createSortedListOfHashes(@options.instagramCompetitorsPages)
    @ownInstagramPages = @_createSortedListOfHashes(@options.ownInstagramPages)
    @twitterCompetitorsPages = @_createSortedListOfHashes(@options.twitterCompetitorsPages)
    @ownTwitterPages = @_createSortedListOfHashes(@options.ownTwitterPages)
    @initializeAccountOptions()

  initializeAccountOptions:() =>
    @accounts = {}
    @accounts["Facebook"] = {}
    @accounts["Twitter"] = {}
    @accounts["Instagram"] = {}
    @accounts["Facebook"]["own"] = @ownFacebookPages
    @accounts["Facebook"]["competitors"] = @facebookCompetitorsPages
    @accounts["Facebook"]["all"] = @_allFacebookAccountOptions()
    @accounts["Twitter"]["own"] = @ownTwitterPages
    @accounts["Twitter"]["competitors"] = @twitterCompetitorsPages
    @accounts["Twitter"]["all"] = @_allTwitterAccountOptions()
    @accounts["Instagram"]["own"] = @ownInstagramPages
    @accounts["Instagram"]["competitors"] = @instagramCompetitorsPages
    @accounts["Instagram"]["all"] = @_allInstagramAccountOptions()

  _createSortedListOfHashes: (accounts) =>
    accounts = _.uniq(accounts, (x) => (x.name).concat(x.id))
    list = _.collect(accounts, (account) => {id: account.id, name: account.name, label: account.name + " (" + account.id + ")"} )
    @_sortByName(list)

  filterOwnAccount:() =>
    activatedSocialNetworkValues = @_activatedSocialNetworkValue()
    @filterByAccountModes(@specialSelectableOptions()[activatedSocialNetworkValues]["own"].concat(@accounts[activatedSocialNetworkValues]["own"]))

  filterThirdPartyAccount:() =>
    activatedSocialNetworkValues = @_activatedSocialNetworkValue()
    @filterByAccountModes(@specialSelectableOptions()[activatedSocialNetworkValues]["competitors"].concat(@accounts[activatedSocialNetworkValues]["competitors"]))

  filterAllAccount:() =>
    activatedSocialNetworkValues = @_activatedSocialNetworkValue()
    @filterByAccountModes(@specialSelectableOptions()[activatedSocialNetworkValues]["all"].concat(@accounts[activatedSocialNetworkValues]["all"]))

  specialSelectableOptions: =>
    {
      "Instagram": {own: @_allInstagramOwn(), competitors:@_allInstagramThirdParty(), all: @_allInstagram()}
      "Twitter": {own: @_allTwitterOwn(), competitors: @_allTwitterThirdParty(), all: @_allTwitter()}
      "Facebook": {own: @_allFacebookOwn() , competitors: @_allFacebookThirdParty(), all: @_allFacebook()}
    }

  _allInstagram:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_instagram')
    [name: name, label: name, id:'ALL_INSTAGRAM']

  _allInstagramOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_instagram_own')
    [name: name, label: name, id:'ALL_INSTAGRAM_OWN']

  _allInstagramThirdParty:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_instagram_competitors')
    [name: name, label: name, id:'ALL_INSTAGRAM_COMPETITORS']

  _allTwitter:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_twitter')
    [name: name, label: name, id:'ALL_TWITTER']

  _allTwitterOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_twitter_own')
    [name: name, label: name, id:'ALL_TWITTER_OWN']

  _allTwitterThirdParty:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_twitter_competitors')
    [name: name, label: name, id:'ALL_TWITTER_COMPETITORS']

  _allFacebook:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_facebook')
    [name: name, label: name, id:'ALL_FACEBOOK']

  _allFacebookOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_facebook_own')
    [name: name, label: name, id:'ALL_FACEBOOK_OWN']

  _allFacebookThirdParty:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_facebook_competitors')
    [name: name, label: name, id:'ALL_FACEBOOK_COMPETITORS']

  filterByAccountModes: (filteredAccounts) =>
    @accountSelectionView.selectedOptions = @accountSelectionView.toObjectArray()
    @accountSelectionView.options = _.uniq(@accountSelectionView.toObjectArray().concat(filteredAccounts), (x) => x.name.concat(x.id))
    @$el.find('#filter-visible-by-statuses').html(@accountSelectionView.render().el)

  onChangeToFacebookSocialNetwork: (event) =>
    @_onChangeSocialNetwork(event, @_allFacebookAccountOptions(), "Facebook")

  onChangeToInstagramSocialNetwork: (event) =>
    @_onChangeSocialNetwork(event, @_allInstagramAccountOptions(), "Instagram")

  onChangeToTwitterSocialNetwork: (event) =>
    @_onChangeSocialNetwork(event, @_allTwitterAccountOptions(), "Twitter")

  _onChangeSocialNetwork: (event, accounts, socialNetwork) =>
    @accountSelectionView.setLabelCustomClass(socialNetwork)
    oldSelected = @_activatedSocialNetworkId()
    currentTargetId = event.currentTarget.id
    if((typeof(oldSelected) == "undefined" ) || (@accountSelectionView.toArray().length == 0))
      accounts = @accounts[socialNetwork][@_activatedAccountMode()]
      accounts = @specialSelectableOptions()[socialNetwork][@_activatedAccountMode()].concat(accounts)
      @_changeAccountListTo(accounts)
    else if (oldSelected != currentTargetId)
      swal({
        title: I18n.t('monitoring.publication_analytics_export.report_confirmation'),
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        cancelButtonText: I18n.t('monitoring.publication_analytics_export.cancel_button'),
        confirmButtonText: I18n.t('monitoring.publication_analytics_export.confirm_button'),
        }, (isConfirm)=>
          if isConfirm
            accounts = @accounts[socialNetwork][@_activatedAccountMode()]
            accounts = @specialSelectableOptions()[socialNetwork][@_activatedAccountMode()].concat(accounts)
            @_changeAccountListTo(accounts)
          else
            event.preventDefault()
            @_rollbackClick(oldSelected, currentTargetId)
      )

  _rollbackClick: (oldSelected, currentTargetId) =>
    @$el.find("##{currentTargetId}").removeClass("active")
    @$el.find("##{oldSelected}").addClass("active")

  _changeAccountListTo: (accounts) =>
    @accountSelectionView.options = accounts
    @accountSelectionView.selectedOptions = []
    @$el.find('#filter-visible-by-statuses').html(@accountSelectionView.render().el)

  _allFacebookAccountOptions: () =>
    @ownFacebookPages.concat(@facebookCompetitorsPages)

  _allTwitterAccountOptions: () =>
    @ownTwitterPages.concat(@twitterCompetitorsPages)

  _allInstagramAccountOptions: () =>
    @ownInstagramPages.concat(@instagramCompetitorsPages)

  download: (event) =>
    event.preventDefault()
    return unless @_validateOptions()
    @_showExportSpinner()
    @_startExportation(@_reportOptions(), I18n.t('monitoring.dashboard.actions.export.error'))
    @_hideExportSpinner()
    swal(
      I18n.t('monitoring.dashboard.actions.export.started'),
      I18n.t('monitoring.dashboard.actions.export.message'),
      'info'
    )

  _validateOptions: =>
    options = @_reportOptions()
    errorMessage = @_validateDates(options)
    errorMessage ||= @_validateAccounts(options)
    if errorMessage
      swal(
        I18n.t('monitoring.dashboard.actions.export.wrong_parameters.alert'),
        errorMessage,
        'error'
      )
    !errorMessage

  _validateDates: (options) =>
    from = new Date(options.from)
    content_creation_to = new Date(options.content_creation_to)
    report_analysis_to = new Date(options.report_analysis_to)
    threeMonthsGap = (content_creation_to - from) <= 92 * (1000 * 3600 * 24)
    if !threeMonthsGap then errorMessage = @_optionsErrorMessage('threeMonthsGap')
    validRelativity = from <= content_creation_to <= report_analysis_to
    if !validRelativity then errorMessage = @_optionsErrorMessage('validRelativity')
    untilToday = report_analysis_to <= moment().toDate()
    if !untilToday then errorMessage = @_optionsErrorMessage('untilToday')
    errorMessage      

  _validateAccounts: (options) =>
    anyUserSelected = options.social_users.length > 0
    if !anyUserSelected then errorMessage = @_optionsErrorMessage('anyUserSelected')
    errorMessage

  _optionsErrorMessage: (optionsError) =>
    messages = {
      threeMonthsGap: I18n.t('monitoring.dashboard.actions.export.wrong_parameters.three_months_gap')
      validRelativity: I18n.t('monitoring.dashboard.actions.export.wrong_parameters.dates_relativity')
      untilToday: I18n.t('monitoring.dashboard.actions.export.wrong_parameters.until_today')
      anyUserSelected: I18n.t('monitoring.dashboard.actions.export.wrong_parameters.no_account_selected')
    }
    messages[optionsError]

  _startExportation: (params, message) =>
    exportJob = new Monitoring.Methods.AnalyticsAsyncJob()
    exportJob.bind('completed', (results) => @_onComplete(results))
    exportJob.bind('failed', (results) => @_onFailure(message))
    exportJob.start(params)

  _onComplete: (results) =>
    window.open(results.path, '_blank');

  _onFailure: (message) =>
    window.showError(message)

  _showExportSpinner: =>
    this.$el.find('#export_spinner').show()

  _hideExportSpinner: =>
    this.$el.find('#export_spinner').hide()

  exportConfirm: =>
    @_alertSuccess()

  exportError: =>
    @_alertError()

  _alertSuccess: =>
    @_hideExportSpinner()
    swal
      title: I18n.t 'customer.reports.modal.export_started_title'
      text: I18n.t 'customer.reports.modal.export_started_message'
      type: 'info'
      html: true

  _alertError: =>
    @_hideExportSpinner()
    swal
      title: I18n.t('monitoring.publication_analytics_export.export_error')
      type: 'error'
      html: true


  requestError: =>
    alert('We are sorry, but something went wrong. Please try again.')

  _activatedSocialNetworkValue: () =>
    @$el.find("#social-network-modes button.active").attr('value')

  _activatedSocialNetworkId: () =>
    @$el.find("#social-network-modes button.active").attr('id')

  _activatedAccountMode: () =>
    @$el.find("#account-modes button.active").attr('id')

  _sortByName: (list) =>
    _.sortBy(list, (x) => x.name)

  _reportOptions: () ->
    from: this.$el.find('#from')[0].value
    content_creation_to: this.$el.find('#to')[0].value
    report_analysis_to: this.$el.find('#offset')[0].value
    timezone: @timezoneSelectorView.getSelectedTimeZone()
    social_network: @_activatedSocialNetworkValue()
    social_users: @_cleanSocialUsersObject(@_handleMultipleSelections(@accountSelectionView.toObjectArray()))

  render: ->
    @$el.html @template
      facebookCompetitorsPages: @facebookCompetitorsPages
      ownFacebookPages: @ownFacebookPages
      instagramCompetitorsPages: @instagramCompetitorsPages
      ownInstagramPages: @ownInstagramPages
      twitterCompetitorsPages: @twitterCompetitorsPages
      ownTwitterPages: @ownTwitterPages
    @_renderDatepickers()
    @_renderTimezoneSelector()
    @_renderSocialAccounts([], [])
    this

  _renderDatepickers: ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$el.find('.datepicker').datepicker
      todayBtn: 'linked'
      autoclose: true
      startDate: threeYearsAgo
    @$el.find('#from_metric').datepicker('update', moment().subtract('weeks', 1).toDate().format('DD-MM-YYYY'))
    @$el.find('#offset_metric').datepicker('update', new Date().format('DD-MM-YYYY'))
    @$el.find('#to_metric').datepicker('update', new Date().format('DD-MM-YYYY'))

  _renderTimezoneSelector: ->
    @timezoneSelectorView = new Monitoring.Views.TimeZoneSelectorView()
    @$el.find('#timezone_selector').html(@timezoneSelectorView.render().el)

  _renderSocialAccounts: (socialAccounts, selected)->
    text_placeholder = I18n.t 'monitoring.publication_analytics_export.select_account'
    @accountSelectionView = @_addSelectView(
      socialAccounts, 'id', 'label', selected,
      text_placeholder, '268px', true, '#filter-visible-by-statuses'
    )
    @accountSelectionView.setLabelCustomClass('facebook')
    inicialAccounts = @specialSelectableOptions()["Facebook"][@_activatedAccountMode()].concat(@_allFacebookAccountOptions())
    @_changeAccountListTo(inicialAccounts)

  _handleMultipleSelections: (allSelected)->
    newSelectedOnlyWithIds = []
    _.each(allSelected, (selectedOption)=>
      if(@_isSpecial(selectedOption))
        specialOptionAccounts = _.collect(@_specialOptions()[selectedOption['id']], (x) => {id: x.id, name: x.name })
        newSelectedOnlyWithIds = newSelectedOnlyWithIds.concat(specialOptionAccounts)
      else
        newSelectedOnlyWithIds.push(selectedOption)
    )
    _.uniq(newSelectedOnlyWithIds, (x) => x.name.concat(x.id))

  _cleanSocialUsersObject: (socialUSers) ->
    _.collect(socialUSers, (x) => {id: x.id, name: x.name})

  _specialOptions:=>
    {
      'ALL_INSTAGRAM_OWN': @ownInstagramPages,
      'ALL_INSTAGRAM_COMPETITORS': @instagramCompetitorsPages,
      'ALL_TWITTER_OWN':@ownTwitterPages,
      'ALL_TWITTER_COMPETITORS': @twitterCompetitorsPages,
      'ALL_FACEBOOK_OWN':@ownFacebookPages,
      'ALL_FACEBOOK_COMPETITORS': @facebookCompetitorsPages,
      'ALL_INSTAGRAM': @ownInstagramPages.concat(@instagramCompetitorsPages),
      'ALL_FACEBOOK': @ownFacebookPages.concat(@facebookCompetitorsPages),
      'ALL_TWITTER': @ownTwitterPages.concat(@twitterCompetitorsPages)
    }

  _isSpecial:(option)=>
    specialOptions = Object.keys(@_specialOptions())
    specialOptions.indexOf(option['id']) >= 0

  _addSelectView: (options, valueProperty, descriptionProperty, selectedOptions, placeholder, width, editable , element) ->
    selectView = new App.APESelectView(
      options: options,
      valueProperty: valueProperty
      descriptionProperty: descriptionProperty
      selectedOptions: selectedOptions
      placeholder: placeholder
      width: width
      editable: editable
    )
    @$el.find(element).append(selectView.el)
    selectView
